export default {
  apiKey: 'AIzaSyAKuidjAsdlgO4cQsc8sZq30yTxNAL3SuY',
  authDomain: 'tklim-trading.firebaseapp.com',
  databaseURL: 'https://tklim-trading.firebaseio.com',
  projectId: 'tklim-trading',
  storageBucket: 'tklim-trading.appspot.com',
  messagingSenderId: '684705642720'
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js